<div class="auth-flow" [class.auth-flow--parent]="isParentLayout()">
  <h3 class="auth-flow__title">{{ 'app.auth.updatePasswordTitle' | translate }}</h3>
  <p class="auth-flow__description">
    {{ 'app.auth.updatePasswordDescription' | translate }}
  </p>

  <form [formGroup]="form">
    <app-input-field
      formControlName="userName"
      [label]="'app.auth.userName' | translate"
      [inputType]="'input'"
      [type]="'text'"
      [validationErrors]="userNameValidation()"
      (keydown.enter)="onSubmit()"
    />

    <app-input-field
      formControlName="code"
      [label]="'app.auth.verificationCode' | translate"
      [inputType]="'input'"
      [type]="'text'"
      [validationErrors]="codeValidation()"
      (keydown.enter)="onSubmit()"
    />

    <app-input-field
      formControlName="password"
      [label]="'app.auth.newPassword' | translate"
      [inputType]="'input'"
      [type]="'password'"
      [validationErrors]="passwordValidation()"
      (keydown.enter)="onSubmit()"
    />

    <app-input-field
      formControlName="confirmPassword"
      [label]="'app.auth.confirmPassword' | translate"
      [inputType]="'input'"
      [type]="'password'"
      [validationErrors]="confirmPasswordValidation()"
      (keydown.enter)="onSubmit()"
    />

    <div class="auth-flow__cta">
      @if (isParentLayout()) {
        <app-parent-button
          [fullWidth]="true"
          [loading]="isLoading()"
          [disabled]="form.invalid"
          (clicked)="onSubmit()"
        >
          {{ 'app.auth.updatePasswordCta' | translate }}
        </app-parent-button>
      } @else {
        <app-cta-button [loading]="isLoading()" [disabled]="form.invalid" (clicked)="onSubmit()">
          <span cta-label>{{ 'app.auth.updatePasswordCta' | translate }}</span>
        </app-cta-button>
      }
    </div>
  </form>

  <button type="button" class="auth-flow__link" (click)="goToSignin()">
    {{ 'app.auth.backToSignIn' | translate }}
  </button>
</div>
